import isFilledUp from './fields/isFilledUp'
import isOTP from './fields/isOTP'

const validateOTP = (name, otp) => {
  if (!isFilledUp(otp)) {
    return { [name]: 'One-Time PIN is required' }
  }
  if (!isOTP(otp)) {
    return { [name]: 'Invalid One-Time PIN' }
  }
  return {}
}

const validate = values => {
  if (typeof values !== 'object' || values === null) {
    throw new Error(
      'Invalid argument. Validator functions only expect a non-null object.',
    )
  }

  const { code } = values

  return {
    ...validateOTP('code', code),
  }
}

export default validate
